import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IProjectDimensionLabel } from '../../../../core/models';
import { LanguageTranslationService } from '../../../../core/services/language-translation.service';

@Component({
  selector: 'app-project-size-dimension',
  templateUrl: './project-size-dimension.component.html',
  styleUrls: ['./project-size-dimension.component.scss']
})
export class ProjectSizeDimensionComponent implements OnInit {
  projectDimentionTxt: IProjectDimensionLabel;
  @Input() thermalCalculatorResource: any;
  @Output() thermalCalculatorResourceEvent = new EventEmitter<any>();
  constructor(private languageTranslationService: LanguageTranslationService) { }

  ngOnInit() {
    this.loadLanguageTranslationData();
  }
  //#region language translate
  loadLanguageTranslationData() {
    const controlNameList = [
      { controlName: "chooseLbl" },
      { controlName: "ftLbl" },
      { controlName: "inLbl" },     
      { controlName: "verticalDloLbl" },     
      { controlName: "horizontalDloLbl" },     

    ];
    const componentName = "projectsizedimension";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.projectDimentionTxt = response[response.length - 1];
    }
    console.log(response);
  }
  projectDimension = {
    chooseLbl:'Choose...',
    ftLbl:'ft',
    inLbl:'in.',
    verticalDloLbl:'Vertical DLO',
    horizontalDloLbl:'Horizontal DLO',
  }
  //#endregion
  dataPostToParent() {
    this.thermalCalculatorResourceEvent.emit(this.thermalCalculatorResource);
  }
}
